import '../App.css'
export default function Footer() {
  return (
    <footer className="footer">

      {/* <div className="footer-brand">SwimWay</div> */}

      <div>© 2026 | THE ROTARY SILVER JUBILEE TRUST, SWIMMING POOL, SANGLI.</div>

      <div style={{ display: 'flex', gap: 20 }}>
        <a className="footer-link" href="#">Privacy</a>
        <a className="footer-link" href="#/terms-condition">Terms & Condition</a>
        <a className="footer-link" href="#">Contact</a>
      </div>

    </footer>
  )
}